import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { FormsModule } from "@angular/forms";
import { DataTableModule } from "angular2-datatable";
import { Ng2Bs3ModalModule } from "ng2-bs3-modal/ng2-bs3-modal";
import { Ng2Webstorage } from "ngx-webstorage/dist/app";
import { FileUploadModule } from "ng2-file-upload/ng2-file-upload";
import { Ng2CompleterModule } from "ng2-completer";
import { EncuestaSaesComponentService } from "./EncuestaSaes.service";
import { EncuestaSaesComponent } from "./EncuestaSaes.component";



@NgModule({
    declarations: [EncuestaSaesComponent],
    imports: [
        BrowserModule,
        Ng2CompleterModule,       
        HttpModule,
        FormsModule,
        DataTableModule,
        Ng2Bs3ModalModule,
        FileUploadModule,
        Ng2Webstorage],
    providers: [EncuestaSaesComponentService]
})

export class EncuestaSaesModule { }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/EncuetasSAES/EncuestaSaes.module.ts